import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import { Backdrop, Button, CircularProgress, Grid, Modal, Stack, useMediaQuery, useTheme } from "@mui/material";
import CustomizePackage from "../../components/weMovePackages/customizePackage";
import FullPackage from "../../components/weMovePackages/fullPackage";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import purpleStackIcon from "../../assets/Icons/purpleStackIcon.png";
import {
  getMoveRequestById,
  updateMoveRequestById,
} from "../../redux/actions/move-request";
import { unwrapResult } from "@reduxjs/toolkit";
import NavBar from "../../components/navbar/navBar";
import { getInventoryVolume } from "../../redux/actions/room-details";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box marginTop={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}

const ModifyPackagingModal = ({modifyPackagingModalVisible, setModifyPackagingModalVisible, moveRequest, setMoveRequest}:any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => {
    setModifyPackagingModalVisible(false)
  }
//   const { moveRequestId } = useParams();
  const [thisMoveRequestId, setThisMoveRequestId] = useState(null);

  const [value, setValue] = useState(0);
  const [isPageLoading, setIsPageLoading] = useState(false);

  const [inventoryVolume, setInventoryVolume] = useState(0.0);

  const navigateToLastLeft = (moveRequest: any) => {
    if (!moveRequest.delivery_details) {
      navigate(`/AddressInfo/${moveRequest.canonical_id}`);
    } else {
      if (moveRequest.delivery_details?.delivery_addresses?.length === 0) {
        navigate(`/AddressInfo/${moveRequest.canonical_id}`);
      } else {
        if (
          moveRequest.delivery_details?.delivery_addresses[0]
            .delivery_location_type === null
        ) {
          navigate(`/DeliveryLocationInfo/${moveRequest.canonical_id}`);
        } else {
          if (moveRequest.delivery_details?.packagaing_required === null) {
            navigate(`/packages/${moveRequest.canonical_id}`);
          } else {
            if (
              moveRequest.pickup_date_from === null &&
              moveRequest.pickup_date_to === null
            ) {
              navigate(`/PickupDate/${moveRequest.canonical_id}`);
            } else {
              if (moveRequest.delivery_details.open_location === null) {
                navigate(`/TruckInfo/${moveRequest.canonical_id}`);
              } else {
                if (moveRequest.items?.length === 0) {
                  navigate(`/itemsInfo/${moveRequest.canonical_id}`);
                } else {
                  navigate(`/move-summary/${moveRequest.canonical_id}`);
                }
              }
            }
          }
        }
      }
    }
  };

  const fetchMoveRequestById = (moveRequestId: any) => {
    setIsPageLoading(true);
    dispatch<any>(getMoveRequestById(moveRequestId))
      .then(unwrapResult)
      .then((thisMoveRequest: any) => {
        setThisMoveRequestId(thisMoveRequest.id);
        setMoveRequest(thisMoveRequest);
    setIsPageLoading(false);
        
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const updateThisMoveRequest = (body: any) => {
    setIsPageLoading(true);
    const params = {
      id: thisMoveRequestId,
      ...body,
    };
    dispatch<any>(updateMoveRequestById(params))
      .then(unwrapResult)
      .then((thisMoveRequest: any) => {
        setMoveRequest(thisMoveRequest);
        setTimeout(() => {
          setIsPageLoading(false);
          setModifyPackagingModalVisible(false)
        }, 1300);
      })
      .catch((err: any) => {
        console.log(err);
        setTimeout(() => {
          setIsPageLoading(false);
        }, 1300);
      });
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const getCubicFeet = () => {
    setIsPageLoading(true)
    const move_request_id = moveRequest.canonical_id || "";
    dispatch<any>(getInventoryVolume(move_request_id))
      .then(unwrapResult)
      .then((res: any) => {
        setInventoryVolume(res.total_cubic_feet);
    setIsPageLoading(false)

      });
  };
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    fetchMoveRequestById(moveRequest.canonical_id);
    if (inventoryVolume === 0.0) {
    
      getCubicFeet();
    }
  }, []);
const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.only("xs"));
  return (
    <Modal
        open={modifyPackagingModalVisible}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "45%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90vw", sm: "80vw", md: "50vw", lg: "50vw" },
            height: isMobile ? "90vh" : "60vh",
            overflow: "auto",
            bgcolor: "background.paper",
            borderRadius: "8px",
            boxShadow: 24,
            border: `4px solid ${theme.palette.primary.main}`,
            padding:3
          }}
        >
          <Typography
            variant="subtitle1"
            fontWeight={700}
            lineHeight={1.2}
            color={"#374145"}
            textAlign="center"
            margin={2}
          >
            {moveRequest.delivery_details?.packagaing_required===true && moveRequest.delivery_details.packaging!==null? 'You have currently subscribed for the following package:': moveRequest.delivery_details?.packagaing_required===false && moveRequest.delivery_details.packaging===null? 'You have not currently subscribed to any packaging:':''}
          </Typography>


        <Box sx={{ width: "100%" }}>
          <Grid item xs={12}>
            <Box
              sx={{
                border: 1,
                borderColor: "#0000001A",
                borderRadius: "25px",
                width: "fit-content",
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom:2
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                centered
                TabIndicatorProps={{
                  style: {
                    display: "none",
                  },
                }}
              >
                <Tab
                  sx={{
                    fontSize: "12px",
                    fontWeight: "700",
                    color: theme.palette.primary.main,
                    borderColor: "#0000001A",
                    borderRadius: "25px",
                    "&.Mui-selected": {
                      backgroundColor: theme.palette.primary.main,
                      color: "#FFFFFF",
                    },
                  }}
                  label="Full package"
                  {...a11yProps(0)}
                />
                {/* <Tab
                  sx={{
                    fontSize: "12px",
                    fontWeight: "700",
                    color: theme.palette.primary.main,
                    borderColor: "#0000001A",
                    borderRadius: "25px",
                    "&.Mui-selected": {
                      backgroundColor: theme.palette.primary.main,
                      color: "#FFFFFF",
                    },
                  }}
                  label="Customize Package"
                  {...a11yProps(1)}
                /> */}
              </Tabs>
            </Box>
          </Grid>
          <Grid item xs={12} md={5} marginLeft={"auto"} marginRight={"auto"}>
      <Box
        p={2}
        sx={{
          backgroundColor: "#F2F4FF",
          border: "1px solid #EAECF0",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <img src={purpleStackIcon} width={40} height={40} alt="" />

        <Typography variant="subtitle2" fontWeight={700} color={theme.palette.primary.main}>
          Wemove Full Package
        </Typography>
        <Typography variant="h5" fontWeight={700}>
          ${Math.ceil(inventoryVolume)}
        </Typography>
        <Typography variant="subtitle2" color={"#667085"}>
          Based on your move, a full pro pack where everything is boxed and
          packed properly
        </Typography>
      </Box>

      <Stack
        direction="row"
        mt={3}
        spacing={2}
        alignItems={'center'}
        justifyContent={"center"}
      >
        {moveRequest.delivery_details?.packagaing_required===true && moveRequest.delivery_details?.packaging!==null&&(
            <Button
            onClick={() => {
                updateThisMoveRequest({
                    delivery_details: {
                        packagaing_required: false,
                    },
                });
            }}
            variant="contained"
            size="medium"
            color="error"
            sx={{
                width: 130,
                height: 50,
                fontSize: 12,
                fontWeight: 550,
            }}
            >
          Discard Packaging
        </Button>
        )}
        {moveRequest.delivery_details?.packagaing_required===false && moveRequest.delivery_details.packaging===null&&(

            <Button
            onClick={() => {
                updateThisMoveRequest({
                    delivery_details: {
                        packagaing_required: true,
                        packaging: {
                            packaging_type: "Full Package",
                            dish_boxes: 0,
                            wardrobe_boxes: 0,
                            med_boxes: 0,
                            large_boxes: 0,
                            book_boxes: 0,
                            small_picture_boxes: 0,
                            medium_picture_boxes: 0,
                            large_picture_boxes: 0,
                            extra_large_picture_boxes: 0,
                            mattress_covers: 0,
                            packing_tapes: 0,
                            tv_boxes: 0,
                            packaging_payment: Math.ceil(inventoryVolume),
                            custom_packaging_preference: "Boxes-and-Packing",
                        },
                    },
                });
            }}
            size="medium"
            sx={{
                width: 130,
                height: 50,
                backgroundColor: `${theme.palette.primary.main} !important`,
                color: "#FFFFFF",
                fontSize: 12,
                fontWeight: 550,
                border: "1px solid #6552FF",
            }}
            >
          Subscribe Packaging
        </Button>
        )}
      </Stack>
    </Grid>
          {/* <CustomTabPanel value={value} index={0}>
            <FullPackage
              updateThisMoveRequest={updateThisMoveRequest}
              totalCubicFeet={inventoryVolume}
              moveRequest={moveRequest}
            />
          </CustomTabPanel> */}

          {/* <CustomTabPanel value={value} index={1}>
            <CustomizePackage
              totalCubicFeet={inventoryVolume}
              updateThisMoveRequest={updateThisMoveRequest}
            />
          </CustomTabPanel> */}
        </Box>

        {isPageLoading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isPageLoading}
            onClick={() => {
              setIsPageLoading(true);
            }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </Box>
    </Modal>
  );
};

export default ModifyPackagingModal;
